import { NgModule } from '@angular/core';
import {
  BackToTopComponent,
  FloatingActionButtonComponent,
  FooterComponent,
  HeaderComponent,
  SectionAnchorComponent,
} from '@ft-alts/ui-components/src/lib/navigation-lib';
import {
  ComponentMapping,
  DynamicModule,
} from '@services/module-loader.config';
@NgModule({})
export class NavigationModule implements DynamicModule {
  constructor() {}

  getComponentMapping(): ComponentMapping {
    return {
      'Alts Back to Top': BackToTopComponent,
      'Alts Floating Action Button': FloatingActionButtonComponent,
      'Alts Footer': FooterComponent,
      'Alts Header': HeaderComponent,
      'Alts Section Anchor': SectionAnchorComponent,
    };
  }
}
